(function () {
  console.log('[EAB Forms validation] Script loaded');

  var initializedForms = [];
  var observers = [];
  var observedRoots = [];
  var scheduleTimer = null;

  var messages = Object.assign({
    personnummer: 'Enter a valid Swedish personal identity number (YYMMDD-XXXX).',
    invoiceEmail: 'Enter a valid invoice email address.',
    SE: 'Enter a valid Swedish postal code with five digits, for example 123 45.',
    DK: 'Enter a valid Danish postal code with four digits.',
    NO: 'Enter a valid Norwegian postal code with four digits.',
    FI: 'Enter a valid Finnish postal code with five digits.',
    DE: 'Enter a valid German postal code with five digits.'
  }, window.eabRegistrationTranslations || {});

  var postalFormats = {
    SE: {
      pattern: /^\d{3}\s?\d{2}$/
    },
    DK: {
      pattern: /^\d{4}$/
    },
    NO: {
      pattern: /^\d{4}$/
    },
    FI: {
      pattern: /^\d{5}$/
    },
    DE: {
      pattern: /^\d{5}$/
    }
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[åä]/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function getFormsEmbeds() {
    return Array.prototype.slice.call(document.querySelectorAll('form-embed, shopify-forms-embed'));
  }

  function getErrorColor(field) {
    var root = field && field.getRootNode ? field.getRootNode() : document;
    var host = root && root.host ? root.host : null;
    var colorSource =
      (host && host.closest('[data-forms-errors-color]')) ||
      document.querySelector('[data-forms-errors-color]');

    return (
      colorSource &&
      (colorSource.dataset.formsErrorsColor || colorSource.getAttribute('data-forms-errors-color'))
    ) || '#e02229';
  }

  function getSearchRoots() {
    var roots = [];
    var embeds = getFormsEmbeds();

    console.log('[EAB Forms validation] Search roots check', {
      embeds: embeds.length,
      hasShadowRoots: embeds.filter(function (embed) { return !!embed.shadowRoot; }).length
    });

    embeds.forEach(function (embed) {
      if (embed.shadowRoot) {
        roots.push(embed.shadowRoot);
      }

      roots.push(embed);

      Array.prototype.forEach.call(embed.querySelectorAll('iframe'), function (frame) {
        try {
          if (frame.contentDocument) {
            roots.push(frame.contentDocument);
          }
        } catch (_) {
          // Cross-origin iframes cannot be accessed from theme JavaScript.
        }
      });
    });

    if (!roots.length) {
      roots.push(document);
    }

    return roots;
  }

  function query(root, selector) {
    try {
      return root.querySelector(selector);
    } catch (_) {
      return null;
    }
  }

  function queryAll(root, selector) {
    try {
      return root.querySelectorAll(selector);
    } catch (_) {
      return [];
    }
  }

  function getInputFromMatch(element) {
    if (!element) {
      return null;
    }

    if (element.tagName === 'OPTION') {
      return element.closest('select');
    }

    if (/^(BUTTON|INPUT|SELECT|TEXTAREA)$/.test(element.tagName)) {
      return element;
    }

    return query(element, 'input:not([type="hidden"]), select, textarea, button');
  }

  function getLabelledByText(field) {
    var root = field.getRootNode ? field.getRootNode() : document;
    var labelledBy = field.getAttribute('aria-labelledby');
    var text = '';

    if (!labelledBy) {
      return '';
    }

    labelledBy.split(/\s+/).forEach(function (id) {
      var label = query(root, '#' + cssEscape(id));
      if (label) {
        text += ' ' + label.textContent;
      }
    });

    return text;
  }

  function getFieldValue(field) {
    if (!field) {
      return '';
    }

    var value = typeof field.value === 'string' ? field.value : '';

    if (field.tagName === 'SELECT' && field.selectedIndex >= 0) {
      value += ' ' + field.options[field.selectedIndex].text;
    }

    if (field.tagName === 'BUTTON') {
      value += ' ' + getLabelledByText(field) + ' ' + field.textContent;
    }

    return value;
  }

  function getFieldText(field, form) {
    var parts = [
      field.getAttribute('data-testid'),
      field.getAttribute('aria-label'),
      field.getAttribute('placeholder'),
      field.getAttribute('name'),
      field.getAttribute('id'),
      getLabelledByText(field)
    ];

    if (field.id && form) {
      var label = query(form, 'label[for="' + cssEscape(field.id) + '"]');
      if (label) {
        parts.push(label.textContent);
      }
    }

    var parentLabel = field.closest('label');
    if (parentLabel) {
      parts.push(parentLabel.textContent);
    }

    return normalize(parts.join(' '));
  }

  function findField(form, selectorList, wordList, fieldSelector) {
    var match = null;

    selectorList.some(function (selector) {
      match = getInputFromMatch(query(form, selector));
      return !!match;
    });

    if (match) {
      return match;
    }

    Array.prototype.some.call(queryAll(form, fieldSelector || 'input, select, textarea'), function (field) {
      if (field.type === 'hidden' || field.disabled) {
        return false;
      }

      var text = getFieldText(field, form);
      var found = wordList.some(function (word) {
        return text.indexOf(word) !== -1;
      });

      if (found) {
        match = field;
      }

      return found;
    });

    return match;
  }

  function findFormRoot(field) {
    return field && (field.form || field.closest('form'));
  }

  function getFieldLabel(field) {
    var root = field && field.getRootNode ? field.getRootNode() : document;
    var labelledBy = field && field.getAttribute('aria-labelledby');
    var label = null;

    if (labelledBy) {
      labelledBy.split(/\s+/).some(function (id) {
        label = query(root, '#' + cssEscape(id));
        return !!label;
      });
    }

    return label || query(root, 'label[for="' + cssEscape(field.id) + '"]') || field.closest('label');
  }

  function addRequiredIndicator(field) {
    var label = field && getFieldLabel(field);

    if (!label || query(label, '[data-eab-required-indicator]')) {
      return;
    }

    var indicator = document.createElement('span');
    indicator.setAttribute('data-eab-required-indicator', '');
    indicator.setAttribute('aria-hidden', 'true');
    indicator.textContent = ' *';
    label.appendChild(indicator);
  }

  function fixFloatingLabels(form, root) {
    if (!root || !root.host) {
      return;
    }

    if (!query(root, '#EabCustomerFloatingLabels')) {
      var style = document.createElement('style');
      style.id = 'EabCustomerFloatingLabels';
      style.textContent = [
        'input[data-eab-filled="true"] + label[class*="_formInputFieldLabel_"],',
        'input:focus + label[class*="_formInputFieldLabel_"] {',
        'top: 3px !important;',
        'transform: none !important;',
        'font-size: 11px !important;',
        'line-height: 1.2 !important;',
        '}'
      ].join('');
      root.appendChild(style);
    }

    function syncField(field) {
      if (field && field.tagName === 'INPUT' && field.nextElementSibling && field.nextElementSibling.matches('label[class*="_formInputFieldLabel_"]')) {
        field.setAttribute('data-eab-filled', String(!!field.value));
      }
    }

    Array.prototype.forEach.call(queryAll(form, 'input'), syncField);
    form.addEventListener('input', function (event) { syncField(event.target); });
    form.addEventListener('change', function (event) { syncField(event.target); });
  }

  function getErrorElement(field) {
    var root = field.getRootNode ? field.getRootNode() : document;

    if (!field.id) {
      field.id = 'CustomerRegistrationField-' + Math.random().toString(36).slice(2);
    }

    var errorId = field.id + '-EabValidationError';
    var error = query(root, '#' + cssEscape(errorId));

    if (!error) {
      error = document.createElement('p');
      error.id = errorId;
      error.className = 'eab-forms-validation__error';
      error.setAttribute('data-eab-validation-error', '');
      error.style.fontSize = '14px';
      error.style.lineHeight = '1.35';
      error.style.margin = '6px 0 0';
      error.hidden = true;

      var wrapper = field.closest('label') || field.parentNode;
      if (wrapper && wrapper.parentNode && (field.type === 'checkbox' || field.type === 'radio')) {
        wrapper.parentNode.insertBefore(error, wrapper.nextSibling);
      } else if (field.parentNode) {
        field.parentNode.insertBefore(error, field.nextSibling);
      }
    }

    return error;
  }

  function setError(field, message) {
    var error = getErrorElement(field);
    var errorColor = getErrorColor(field);

    if (!error) {
      return;
    }

    if (message) {
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', error.id);
      field.style.borderColor = errorColor;
      if (field.setCustomValidity) {
        field.setCustomValidity(message);
      }
      error.style.color = errorColor;
      error.textContent = message;
      error.hidden = false;
    } else {
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
      field.style.borderColor = '';
      if (field.setCustomValidity) {
        field.setCustomValidity('');
      }
      error.textContent = '';
      error.hidden = true;
    }
  }

  function countryCode(countryField) {
    if (!countryField) {
      return '';
    }

    var value = normalize(getFieldValue(countryField));

    if (/(^|\s)(se|sverige|sweden|sv)(\s|$)/.test(value)) return 'SE';
    if (/(^|\s)(dk|danmark|denmark)(\s|$)/.test(value)) return 'DK';
    if (/(^|\s)(no|norge|norway)(\s|$)/.test(value)) return 'NO';
    if (/(^|\s)(fi|finland)(\s|$)/.test(value)) return 'FI';
    if (/(^|\s)(de|tyskland|germany|deutschland)(\s|$)/.test(value)) return 'DE';

    return '';
  }

  function findSelectedCountryField(form) {
    var countrySelectors = [
      '[data-testid*="country" i] input:checked',
      '[data-testid*="land" i] input:checked',
      'input[name*="country" i]:checked',
      'input[name*="land" i]:checked',
      'input[id*="country" i]:checked',
      'input[id*="land" i]:checked',
      'input[value="se" i]:checked',
      'input[value="sv" i]:checked',
      'input[value="dk" i]:checked',
      'input[value="no" i]:checked',
      'input[value="fi" i]:checked',
      'select[name*="country" i]',
      'select[name*="land" i]',
      'select[id*="country" i]',
      'select[id*="land" i]',
      'select:has(option[value="se" i])',
      'select:has(option[value="sv" i])',
      'select:has(option[value="dk" i])',
      'select:has(option[value="no" i])',
      'select:has(option[value="fi" i])'
    ];
    var match = null;

    countrySelectors.some(function (selector) {
      match = query(form, selector);
      return !!match;
    });

    return match;
  }

  function getCountryCode(form, countryField) {
    var explicitCountryCode = countryCode(countryField);
    var selectedCountryField = findSelectedCountryField(form);
    var selectedCountryCode = countryCode(selectedCountryField);

    return explicitCountryCode || selectedCountryCode || 'SE';
  }

  function dispatchValidationState(field) {
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function isValidPersonnummer(value) {
    var trimmed = value.trim();

    if (!/^(\d{6}|\d{8})-?\d{4}$/.test(trimmed)) {
      return false;
    }

    var digits = trimmed.replace('-', '');

    if (digits.length === 10 && parseInt(digits.substring(0, 2), 10) < 50) {
      digits = '20' + digits;
    } else if (digits.length === 10) {
      digits = '19' + digits;
    }

    if (digits.length !== 12) {
      return false;
    }

    var luhnDigits = digits.substring(2);
    var sum = 0;

    for (var i = 0; i < 9; i++) {
      var n = parseInt(luhnDigits[i], 10);
      if (i % 2 === 0) {
        n *= 2;
      }
      if (n > 9) {
        n -= 9;
      }
      sum += n;
    }

    var controlDigit = parseInt(luhnDigits[9], 10);
    return (sum + controlDigit) % 10 === 0;
  }

  function validatePersonnummer(field) {
    if (!field.value.trim()) {
      setError(field, '');
      return true;
    }

    if (!isValidPersonnummer(field.value)) {
      setError(field, messages.personnummer);
      return false;
    }

    setError(field, '');
    return true;
  }

  function validatePostal(field, countryField, form) {
    var code = getCountryCode(form, countryField);
    var format = postalFormats[code];

    if (!field.value.trim()) {
      setError(field, '');
      return true;
    }

    if (format && !format.pattern.test(field.value.trim())) {
      setError(field, messages[code] || copy.en[code]);
      return false;
    }

    setError(field, '');
    return true;
  }

  function validateInvoiceEmail(field) {
    var value = field.value.trim();

    if (!value) {
      setError(field, '');
      return true;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError(field, messages.invoiceEmail);
      return false;
    }

    setError(field, '');
    return true;
  }

  function setupForm(form) {
    if (!form || initializedForms.indexOf(form) !== -1) {
      return;
    }

    var formRoot = form.getRootNode ? form.getRootNode() : null;
    var formsHost = formRoot && formRoot.host;
    var formsBlock = formsHost && formsHost.closest('[data-forms-id]');

    if (!formsBlock || ['forms-root-1231841', 'forms-root-1092251'].indexOf(formsBlock.getAttribute('data-forms-id')) === -1) {
      return;
    }

    console.log('[EAB Forms validation] Form candidate found', form);

    var fields = {
      firstName: findField(form, [
        '[data-testid="field-first_name"]',
        '[data-testid="field-customer_first_name"]',
        '#first_name',
        '#customer_first_name'
      ], ['fornamn', 'first name', 'given name']),
      lastName: findField(form, [
        '[data-testid="field-last_name"]',
        '[data-testid="field-customer_last_name"]',
        '#last_name',
        '#customer_last_name'
      ], ['efternamn', 'last name', 'family name']),
      personnummer: findField(form, [
        '[data-testid="field-custom#social_security_number"]',
        '#custom\\#social_security_number',
        '[id="custom#social_security_number"]',
        '[id*="social_security_number" i]',
        '[name*="social_security_number" i]'
      ], ['personnummer', 'social security number', 'personal identity number'], 'input, textarea'),
      email: findField(form, [
        '[data-testid="field-email"]',
        '[data-testid="field-customer_email"]',
        '#email',
        '#customer_email'
      ], ['e-post', 'epost', 'email'], 'input, textarea'),
      invoiceEmail: findField(form, [
        '[data-testid="field-custom#invoice_email"]',
        '[id="custom#invoice_email"]',
        '[name="custom#invoice_email"]'
      ], ['invoice email', 'faktura email', 'fakturamejl', 'faktura e-post'], 'input, textarea'),
      address: findField(form, [
        '[data-testid="field-custom#street_address"]',
        '[id="custom#street_address"]',
        '[data-testid="field-shipping_address_address1"]',
        '[data-testid="field-address1"]',
        '#shipping_address_address1',
        '#address1'
      ], ['gatuadress', 'street address', 'address1', 'shipping address'], 'input, textarea'),
      postal: findField(form, [
        '[data-testid="field-custom#zip_code"]',
        '[data-testid="field-shipping_address_zip"]',
        '[data-testid="field-postal_code"]',
        '[data-testid="field-zip"]',
        '[id="custom#zip_code"]',
        '#shipping_address_zip',
        '#postal_code',
        '#zip'
      ], ['postnummer', 'postal', 'zip'], 'input, textarea'),
      city: findField(form, [
        '[data-testid="field-custom#city"]',
        '[data-testid="field-shipping_address_city"]',
        '[data-testid="field-city"]',
        '[id="custom#city"]',
        '#shipping_address_city',
        '#city'
      ], ['ort', 'stad', 'city'], 'input, textarea'),
      country: findField(form, [
        '[data-testid="field-shipping_address_country"]',
        '[data-testid="field-custom#country"]',
        '[data-testid="field-country"]',
        '[data-testid*="country" i]',
        '[data-testid*="land" i]',
        'button[aria-labelledby*="country-selector"]',
        'button[aria-labelledby*="land-selector"]',
        'button[aria-labelledby*="custom#country-selector"]',
        '#shipping_address_country',
        '#country',
        '[id="custom#country"]',
        '[id="custom#country-selector-value"]',
        '[id*="country" i]',
        '[id*="land" i]',
        '[name*="country" i]',
        '[name*="land" i]',
        'select option[value="se" i]',
        'select option[value="sv" i]',
        'select option[value="dk" i]',
        'select option[value="no" i]',
        'select option[value="fi" i]'
      ], ['land', 'country'], 'button, input, select, textarea'),
      terms: findField(form, [
        'input[name="custom#avtalsvillkor"]',
        '[id^="custom#avtalsvillkor-"]',
        'input[name="custom#terms_accepted"]',
        '[id^="custom#terms_accepted-"]',
        '[data-testid="field-terms"] input',
        '[data-testid="field-terms_and_privacy"] input',
        '[data-testid="field-privacy"] input',
        '#terms',
        '#terms_and_privacy'
      ], ['villkor', 'integritet', 'privacy', 'terms'], 'input[type="checkbox"], input[type="radio"]')
    };

    if (!fields.postal) {
      console.log('[EAB Forms validation] Form skipped, required field mapping incomplete', fields);
      return;
    }

    initializedForms.push(form);
    console.log('[EAB Forms validation] Validation attached', fields);

    fixFloatingLabels(form, formRoot);

    [
      fields.firstName,
      fields.lastName,
      fields.personnummer,
      fields.email,
      fields.invoiceEmail,
      fields.address,
      fields.postal,
      fields.city,
      fields.country,
      fields.terms
    ].forEach(addRequiredIndicator);

    addRequiredIndicator(query(form, '#phone_number'));

    if (fields.email && fields.email.tagName === 'INPUT') {
      fields.email.type = 'email';
      fields.email.autocomplete = fields.email.autocomplete || 'email';
    }

    function validateField(field) {
      switch (field) {
        case fields.personnummer:
          return validatePersonnummer(field);
        case fields.invoiceEmail:
          return validateInvoiceEmail(field);
        case fields.postal:
          return validatePostal(field, fields.country, form);
        default:
          return true;
      }
    }

    function validateForm() {
      var invalidFields = [];

      Object.keys(fields).forEach(function (key) {
        var field = fields[key];

        if ((field === fields.personnummer || field === fields.invoiceEmail || field === fields.postal) && !validateField(field)) {
          invalidFields.push(field);
        }
      });

      return invalidFields;
    }

    function isInvoiceEmailField(field) {
      return field && (
        field.getAttribute('data-testid') === 'field-custom#invoice_email' ||
        field.id === 'custom#invoice_email'
      );
    }

    form.addEventListener('blur', function (event) {
      if (isInvoiceEmailField(event.target)) {
        validateInvoiceEmail(event.target);
      }
    }, true);

    form.addEventListener('input', function (event) {
      if (isInvoiceEmailField(event.target) && event.target.getAttribute('aria-invalid') === 'true') {
        validateInvoiceEmail(event.target);
      }
    }, true);

    Object.keys(fields).forEach(function (key) {
      var field = fields[key];

      if (!field || key === 'invoiceEmail') {
        return;
      }

      if (key === 'country') {
        field.addEventListener('change', function () {
          if (fields.postal && fields.postal.value.trim()) {
            validatePostal(fields.postal, fields.country, form);
          }
        });
        return;
      }

      field.addEventListener('blur', function () {
        validateField(field);
      });

      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') {
          validateField(field);
        }
      });

      field.addEventListener('change', function () {
        validateField(field);

        if (field === fields.country && fields.postal && fields.postal.value.trim()) {
          validatePostal(fields.postal, fields.country, form);
        }
      });
    });

    form.addEventListener('submit', function (event) {
      fields.invoiceEmail = findField(form, [
        '[data-testid="field-custom#invoice_email"]',
        '[id="custom#invoice_email"]',
        '[name="custom#invoice_email"]'
      ], ['invoice email', 'faktura email', 'fakturamejl', 'faktura e-post'], 'input, textarea');

      var invalidFields = validateForm();

      if (invalidFields.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        invalidFields[0].focus();
        dispatchValidationState(invalidFields[0]);
      }
    }, true);
  }

  function initFormsValidation() {
    console.log('[EAB Forms validation] Init scan');

    getSearchRoots().forEach(function (root) {
      Array.prototype.forEach.call(queryAll(root, 'form'), setupForm);
    });
  }

  function scheduleInit() {
    window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(initFormsValidation, 200);
  }

  function observeRoot(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (observedRoots.indexOf(root) !== -1) {
      return;
    }

    observedRoots.push(root);

    var observer = new MutationObserver(scheduleInit);
    observer.observe(root, {
      childList: true,
      subtree: true
    });
    observers.push(observer);
  }

  function observeFormsEmbed() {
    console.log('[EAB Forms validation] Observe embeds', getFormsEmbeds().length);

    getFormsEmbeds().forEach(function (embed) {
      observeRoot(embed);

      if (embed.shadowRoot) {
        observeRoot(embed.shadowRoot);
      }
    });

    scheduleInit();
  }

  function start() {
    var style = document.createElement('style');
    style.textContent = [
      '.eab-forms-validation__error { color: #c20000; font-size: 14px; line-height: 1.35; margin: 6px 0 0; }',
      '[aria-invalid="true"] { border-color: #c20000 !important; }'
    ].join('');
    document.head.appendChild(style);

    observeFormsEmbed();

    var docObserver = new MutationObserver(observeFormsEmbed);
    docObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    observers.push(docObserver);

    [500, 1500, 3000, 6000, 12000].forEach(function (delay) {
      window.setTimeout(observeFormsEmbed, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
